import React from "react";
import { Route, Routes } from "react-router-dom";
import { SubmissionsList, SubmissionsDetails } from "./containers";

export const Submissions = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<SubmissionsList />} />
        <Route path="/details/:id" element={<SubmissionsDetails />} />
      </Routes>
    </>
  );
};
